import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { BlockFactory } from '../../../blockly/BlockFactory';
import { useRoute, useRouter } from 'vue-router';
import { backToBlocklyPage } from "../functional/backToBlocklyPage";
import { ShapeSettings } from '../../../blockly/setting/ShapeSettings';
import { block_translation } from '../../../lang/BlockTranslation';

interface Prop{
  assetPath:string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SrcElementButton',
  props: {
    assetPath: null
  },
  setup(__props: any) {

const props = __props as {
  assetPath:string
};


const route = useRoute();
const router = useRouter();
const t = block_translation;
const buttonName = t.to("ファイルパス","file_path");

const addSrcAttribute = async (): Promise<void> => {
  console.log('addSrcAttribute',props.assetPath);
  const factory = new BlockFactory();
  // const srcAtt = await factory.getImageSrcAttribute(props.assetPath);
  const srcAtt = await factory.getSrcAttribute(props.assetPath);

  factory.addWorkspaceAfterMounted(srcAtt.toXml());
  MessageDialog.info(`ファイルパスブロックを追加しました`);
  backToBlocklyPage(route,router);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-outline-dark",
    onClick: addSrcAttribute
  }, _toDisplayString(_unref(buttonName)) + " ", 1))
}
}

})